import * as React from 'react';

import AnnotationsDrawing16 from './AnnotationsDrawing16';

export const annotationsDrawing16 = () => <AnnotationsDrawing16 />;

export default {
    title: 'Icon/Fill/AnnotationsDrawing16',
    component: AnnotationsDrawing16,
    parameters: {
        notes: "`import AnnotationsDrawing16 from 'box-ui-elements/es/icon/fill/AnnotationsDrawing16';`",
    },
};
